import React from "react";
import { mockData } from "../mock";

const Team = () => {
  const teamMembers = [
    {
      id: 1,
      name: "Vish Narain",
      image: "/images/team_vish_3.png",
      bio: [
        "Vish Narain has over two decades of experience in Private Equity. He was employee #2 at TPG India in 2007 and was promoted to Partner and Country Head of TPG Growth in 2012.",
        "At 42, he was the youngest Country Manager at TPG across the world. He led the group for six years and deployed about a billion dollars in healthcare, technology, financial services and consumer across the South Asia region and its neighbourhood (India, Myanmar, Sri Lanka, Vietnam and Africa)",
        "He has served on over 15 Boards of companies in the healthcare, technology and consumer sectors",
        "Prior to his stint at TPG, Vish was an Engagement Manager at McKinsey and Company's Private Equity practice in Palo Alto and London.",
        "Vish has completed his MBA at Stanford University's Graduate School of Business, holds a Master of Technology from the Indian Institute of Technology, New Delhi and a Diploma in Global Leadership and Public Policy from the Kennedy School of Government, Harvard University.",
        "He was selected as a Young Global Leader in 2014, is an active member of the World Economic Forum and serves on its Advisory Board. Vish was also nominated as an Aspen Fellow in 2014 and is a member of the Aspen Leadership Institute.",
        'He was nominated for Business Today\'s "40 under 40" and has been featured in several publications including the cover of Forbes India.',
      ],
    },
    {
      id: 2,
      name: "Saurabh Rai",
      image: "/images/team_saurabh.png",
      bio: [
        "Extensive experience in the restaurant business across Canada, the US and Asia Pacific",
        "Worked across multiple functions including business development, restaurant operations and project management",
        "Graduated from the University of British Columbia with a Masters in Engineering",
        "Significant experience in scaling restaurant businesses and bringing innovations to market",
        "Prior to Ambrosia, led the expansion of Biryani by Kilo across multiple international markets",
        "Instrumental in building the brand presence in the Middle East",
      ],
    },
    {
      id: 5,
      name: "Rohit Madhogarhia",
      image: "/images/team_rohit.png",
      bio: [
        "Over 10 years of experience across management consulting, investment banking, digital strategy, and investments",
        "Prior to joining Pulsar Capital, worked in Pure Health's M&A team, leading key transactions",
        "Led a $500 million investment in Ardent Health Services (US) and the $1.2 billion acquisition of Circle Health Group (UK)",
        "Played a key role in Pure Health's 2023 ADX public listing",
        "Previously worked at NMC Health's Venture Investments & Digital Strategy team and J.P. Morgan's Debt Capital Markets team",
        "Commerce graduate from Shri Ram College of Commerce, University of Delhi, with an MBA from the Indian Institute of Foreign Trade and a CFA Charterholder",
      ],
    },
    {
      id: 4,
      name: "Wissam El Beaino",
      image: "/images/team_wissam.png",
      bio: [
        "With 16+ years of F&B experience, Wissam leads the UAE operations for Furn Beaino, where he plays a central role in shaping the company's growth strategy, product innovation, and operational execution",
        "He brings a strong entrepreneurial mindset and a deep passion for food and brand-building, with a focus on delivering quality, consistency, and customer satisfaction",
        "Wissam's leadership continues to drive the brand's performance in the market",
        "Choosing to set aside his master's degree in engineering, he dedicated himself to drive the brand's performance in the market",
      ],
    },
    {
      id: 6,
      name: "Bipin Pande",
      image: "/images/team_bipin.png",
      bio: [
        "Launched food delivery in the UAE at Zomato to scaling delivery-first brands at Kitopi",
        "Journey has always revolved around food, tech, and building things that matter",
        "Worked across sales, brand acquisition, strategy, and M&A",
        "Helps companies grow through operational clarity, market expansion, and brand storytelling",
        "Now serves as Business Head under Pulsar Capital's F&B investment platform",
        "Building a multi-brand restaurant group across the GCC — acquiring, incubating, and scaling high-potential concepts",
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <div className="relative h-64 md:h-80 lg:h-96">
        {/* Desktop banner */}
        <img
          src="/images/team_banner_2.png"
          alt="Team Banner"
          className="w-full h-full object-cover"
          style={{ objectPosition: "right" }}
        />
        <div className="absolute inset-0 bg-black bg-opacity-40">
          <div className="max-w-7xl mx-auto px-6 h-full flex items-center">
            {/* Mobile text */}
            <div className="text-left max-w-2xl md:hidden">
              <h2 className="text-2xl font-bold text-white mb-0 -mt-24">
                Meet the experts!
              </h2>
              <p className="text-gray-300 text-xs">
                Learn about our world-class, collaborative, multi-culinary team
                who bring decades of experience!
              </p>
            </div>
            {/* Tablet text */}
            <div className="text-left max-w-2xl hidden md:block lg:hidden">
              <p className="text-orange-400 font-semibold uppercase tracking-wide mb-3">
                OUR TEAM
              </p>
              <h1 className="text-3xl font-bold text-white mb-4">
                Meet the experts!
              </h1>
              <p className="text-gray-300 text-base">
                Learn more about our world-class,
                <br />
                collaborative, multi-culinary team <br />
                who bring decades of experience!
              </p>
            </div>
            {/* Desktop text */}
            <div className="text-left max-w-2xl hidden lg:block">
              <p className="text-orange-400 font-semibold uppercase tracking-wide mb-4">
                OUR TEAM
              </p>
              <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
                Meet the experts!
              </h1>
              <p className="text-gray-300 text-lg">
                Learn more about our world-class,
                <br />
                collaborative, multi-culinary team who bring decades of
                experience!
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Team Members Section */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="space-y-16">
          {teamMembers.map((member, index) => (
            <div
              key={member.id}
              className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start"
            >
              {/* Member Image */}
              <div className={`${index % 2 === 1 ? "lg:order-2" : ""}`}>
                <div
                  className="relative h-80 lg:h-96 rounded-2xl overflow-hidden shadow-xl"
                  style={{
                    background: "linear-gradient(to bottom, #262626, #544445)",
                  }}
                >
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              {/* Member Info */}
              <div className={`${index % 2 === 1 ? "lg:order-1" : ""}`}>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">
                  {member.name}
                </h2>
                <div className="prose max-w-none">
                  <ul className="text-gray-600 leading-relaxed space-y-3">
                    {member.bio.map((point, index) => (
                      <li key={index} className="flex items-start">
                        <span className="mr-3 mt-2 w-1.5 h-1.5 bg-orange-500 rounded-full flex-shrink-0"></span>
                        <span>{point}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Team;
